import { UNGROUPED_PERMISSION_AREA } from '../constants/permissions'
import type { AssignableDomain } from '../types/permissions.types'

// Case-insensitive match of the query against a domain's name, description, area (as shown, so an
// ungrouped domain matches "Other") or any of its role names; an empty query keeps every domain.
export const filterDomains = (
  domains: AssignableDomain[],
  query: string
): AssignableDomain[] => {
  const needle = query.trim().toLowerCase()

  if (!needle) return domains

  return domains.filter((domain) =>
    [
      domain.name,
      domain.description,
      domain.area || UNGROUPED_PERMISSION_AREA,
      ...domain.roles.map((role) => role.name),
    ].some((value) => value?.toLowerCase().includes(needle))
  )
}
